import { useCallback, useEffect, useRef, useState } from "react";

// [ms, current row, light phase, loader beat] — prototype WEL_TIMELINE (Aperture).
// Rows 0-2 are the status lines; row 3 is the loader, whose text swaps between two beats.
export const WELCOME_TIMELINE: [number, number, number, number][] = [
  [250, 0, 1, 1],
  [1350, 1, 2, 1],
  [2450, 2, 3, 1],
  [3550, 3, 4, 1],
  [4550, 3, 4, 2],
];
export const WELCOME_TOTAL_MS = 5500;
export const WELCOME_LOADER_ROW = 3;

export default function useWelcomeSequence() {
  const [current, setCurrent] = useState(-1);
  const [phase, setPhase] = useState(1);
  const [beat, setBeat] = useState(1);
  const [done, setDone] = useState(false);
  const timers = useRef<ReturnType<typeof setTimeout>[]>([]);

  const clear = () => {
    timers.current.forEach(clearTimeout);
    timers.current = [];
  };

  useEffect(() => {
    timers.current = WELCOME_TIMELINE.map(([ms, cur, p, b]) =>
      setTimeout(() => {
        setCurrent(cur);
        setPhase(p);
        setBeat(b);
      }, ms)
    );
    timers.current.push(setTimeout(() => setDone(true), WELCOME_TOTAL_MS));
    return clear;
  }, []);

  const skip = useCallback(() => {
    clear();
    setCurrent(WELCOME_LOADER_ROW);
    setPhase(4);
    setBeat(2);
    setDone(true);
  }, []);

  return { current, phase, beat, done, skip };
}
